import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    useNavigate,
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import MInput from '../../Components/Input';
import Overlay from '../../Components/Overlay';
import { NumberFormat } from '../../Components/NumberFormat';
import Swal from 'sweetalert2';
import { isObjectEmpty } from '../../Utils/Utils';
import {createBank, getAllBanks, updateBank} from '../../Service/BanksService';
import {getAllInsertedDealers} from '../../Service/DealerService';
import { InputSwitch } from 'primereact/inputswitch';
import { useSelector } from 'react-redux';

const { $ } = window;
let processingId = -1;
const Banks = () => {
    const { userInfo } = useSelector(state => state.auth);
    const tableDealer = useRef();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [state, setState] = useState({
        BankCode: "",
        Account: '',
        AccountName: '',
        is_active:false
    })
    const mTable = useRef();
    const onAddData = () => {
        $("#modal-payment").modal();
    }

    const onView = item => () => {
        navigate("/operationalcost/view/" + item.id);
    };

    const onHideModal = () => {
        $("#modal-payment").modal('hide');
    }

    const onHideModalMHC = () => {
        $("#modal-mhc").modal('hide');
        $("#modal-payment").modal('show');
    }

    const onSubmit = () => {
        let message = "";
        if (message != "") {
            Swal.fire({
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                title: "Please correct form",
                text: message
            });
            return;
        }
        let payload = {
            ...state, bplid: selected_dealer.bplid, bplname: selected_dealer.bplname,
        }

        createBank(payload).then(res => {
            if (res.status == 200) {
                Swal.fire({
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    title: "Success",
                    text: res.message
                });
                mTable.current.refresh();
                $("#modal-payment").modal('hide');
                setState({
                    BankCode: "",
                    Account: '',
                    AccountName: '',
                    is_active:false
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                    title: "Error",
                    text: res.message
                });
            }
        });
        

    }

    const [selected_dealer, setSelectedDealer] = useState({});

    const columns = [
        { id: 1, title: 'Bank Code', field: 'BankCode', sortable: true },
        { id: 2, title: 'Account', field: 'Account', sortable: true },
        { id: 9, title: 'Dealer Name', field: 'bplname', sortable: true },
        { id: 3, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD', example: 2023-03-01. You can also exclude the date, or month. Example : 2023-03 and 2023"},
        {
            id: 4,
            title: 'Active Status',
            field: 'is_active',
            sortable: true,
            render: data => {
                return <InputSwitch checked={data.is_active} disabled/>
            },
        },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div style={{display:"flex", flexDirection: "column"}}>
                          <a
                            onClick={(e) => onBankActivation(item, true)}
                            style={{
                                cursor: 'pointer',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fa fa-check" style={{color:"green"}}/>
                            <span style={{ marginLeft: 10 }}>Activate</span>
                        </a>
                        <a
                            onClick={(e) => onBankActivation(item, false)}
                            style={{
                                cursor: 'pointer',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fa fa-times" style={{color:"red"}}/>
                            <span style={{ marginLeft: 10 }}>Deactivate</span>
                        </a>

                    </div>
                );
            },
        },
    ];

    const onBankActivation = (item, status) => {
        const text = status === true ? "activate": "deactivate";
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to ${text} this bank?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: `Yes, ${text} it!`
        }).then((result) => {
            if (result.isConfirmed) {
                updateBank(item.id, {is_active:status}).then(res => {
                    if (res.status == 200) {
                        Swal.fire({
                            icon: 'success',
                            timer: 1500,
                            showConfirmButton: false,
                            title: "Success",
                            text: res.message
                        });
                        mTable.current.refresh();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            timer: 1500,
                            showConfirmButton: false,
                            title: "Error",
                            text: res.message
                        });
                    }
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        timer: 1500,
                        showConfirmButton: false,
                        title: "Error",
                        text: "An error occured. Please try again later"
                    });
                
                })
            }
        })
    }

    const onShowNHCModal = () => {
        $('#modal-payment').modal('hide');
        $('#modal-mhc').modal('show');
        tableDealer.current.reset();
    }

    
    const onSelectDealer = item => () => {
        setSelectedDealer(item);
        $('#modal-mhc').modal('hide');
        $('#modal-payment').modal('show');
    }

    
    const columnsDealer = [
        { id: 1, title: 'Card Code', field: 'cardcode', sortable: true },
        { id: 2, title: 'Card Name', field: 'cardname', sortable: true },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={onSelectDealer(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-check" />
                            <span style={{ marginLeft: 10 }}>Select</span>
                        </a>
                    </div>
                );
            },
        }
    ];


    const propsTable = { columns, getData: getAllBanks, showIndex: true, showAddButton: true, onAddData, order: 'created_date', direction: 'desc' };
    const propsTableDealer = { columns: columnsDealer, getData: getAllInsertedDealers, showIndex: true, enablePerPage: false, order:'cardcode' };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Dealer Banks</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <div className='table-responsive'>
                                <MTable ref={mTable}  {...propsTable} />
                            </div>
                        </div>
                    </div>
                    <div id="modal-mhc" className='modal fade' style={{zIndex:"100001 !important"}}>
                        <div className="modal-dialog modal-lg" style={{ maxWidth: 1000 }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title"> Select MHC</h5>
                                    <button type="button"  aria-label="Close"  onClick={onHideModalMHC}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                     <MTable ref={tableDealer} {...propsTableDealer} />
                                </div>
                                <div className="modal-footer">
                                    <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal"><i className="fa fa-times"></i> Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-payment" className='modal'>
                        <Overlay display={state.processing} />
                        <div className='modal-dialog modal-dialog-centered modal-lg'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <h5 className="modal-title"> New Bank</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className='modal-body'>
                                <div className="row" style={{ padding: '10px 65px' }}>
                                            <div className="col-md-12" >
                                                <div className="form-group">
                                                    <label htmlFor="">Modena Home Center <span style={{color:"red"}}>*</span></label>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" value={selected_dealer.cardname} readOnly={true} onChange={(e) => setSelectedDealer(e.target.value)} />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-outline-secondary" type="button" onClick={onShowNHCModal}><i className="fa fa-search"></i></button>
                                                        </div>
                                                    </div>
                                                    {/*errors.user_branch_name && <span className='text-danger' style={{ fontSize: 12 }}>{errors.user_branch_name.message}</span>*/}
                                                </div>
                                            </div>
                                    </div>
                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <MInput
                                                name='BankCode'
                                                label='Bank Code'
                                                type='text'
                                                value={state.BankCode}
                                                onChange={e => setState({...state, BankCode:e.target.value}) }
                                                required
                                            />
                                            {errors && errors.BankCode && <span style={{color:"red"}}>{errors.BankCode}</span>}
                                        </div>
                                    </div>
                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <MInput
                                                name='Account'
                                                label='Account'
                                                type='text'
                                                value={state.Account}
                                                onChange={e => setState({...state, Account:e.target.value}) }
                                                required
                                            />
                                            {errors && errors.Account && <span style={{color:"red"}}>{errors.Account}</span>}
                                        </div>
                                    </div>
                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <MInput
                                                name='AccountName'
                                                label='Account Name'
                                                type='text'
                                                value={state.AccountName}
                                                onChange={e => setState({...state, AccountName:e.target.value}) }
                                                required
                                            />
                                            {errors && errors.AccountName && <span style={{color:"red"}}>{errors.AccountName}</span>}
                                        </div>
                                    </div>
                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <InputSwitch
                                                checked={state.is_active}
                                                onChange={e => setState({...state, is_active:e.value}) }
                                            />
                                            <label style={{marginLeft:10}}>Active Status</label>
                                        </div>
                                    </div>
                                    <div className='row' style={{ justifyContent: 'flex-end', padding: '10px 65px' }}>
                                        <div className='col-sm-2'>
                                            <button className="btn btn-readonly btn-block" style={{ marginBottom: 30 }} type="button" onClick={onHideModal} >
                                                Cancel
                                            </button>
                                        </div>
                                        <div className='col-sm-2'>
                                            <button className="btn btn-modena btn-block" disabled={!isObjectEmpty(errors)} style={{ marginBottom: 30 }} type="button" onClick={onSubmit} >
                                                Submit
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default Banks;